export function PermissionDenied() {
  return (
    <main>
      <h1>Access Denied</h1>
      <p>You do not have permission to view this page.</p>
    </main>
  )
}
